module.exports = __webpack_public_path__ + "img/f6c324105a64e036f9e668224c23e501.72191fd5.jpg";